if (!customElements.get('em-gift-note')) {
  class EmGiftNote extends HTMLElement {
    connectedCallback() {
      this.marker = this.dataset.marker || 'Geschenknachricht:';
      this.checkbox = this.querySelector('[data-em-gift-toggle]');
      this.panel = this.querySelector('[data-em-gift-panel]');
      this.textarea = this.querySelector('[data-em-gift-message]');
      this.counter = this.querySelector('[data-em-gift-count]');
      this.error = this.querySelector('[data-em-gift-error]');
      this.noteField = this.closest('cart-note') && this.closest('cart-note').querySelector('textarea[name="note"]');
      this.max = this.textarea ? parseInt(this.textarea.getAttribute('maxlength') || '100', 10) : 100;
      this.root = this.closest('cart-drawer, cart-form, form') || document;

      this.onToggle = this.onToggle.bind(this);
      this.onMessageInput = this.onMessageInput.bind(this);
      this.onCheckoutClick = this.onCheckoutClick.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);

      if (this.checkbox) {
        this.checkbox.addEventListener('change', this.onToggle);
      }
      if (this.textarea) {
        this.textarea.addEventListener('input', this.onMessageInput);
      }

      document.addEventListener('click', this.onCheckoutClick, true);
      const form = this.closest('form');
      if (form) form.addEventListener('submit', this.onFormSubmit);

      this.syncPanel();
      this.updateCount();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onCheckoutClick, true);
      const form = this.closest('form');
      if (form) form.removeEventListener('submit', this.onFormSubmit);
    }

    onToggle() {
      this.syncPanel();
      this.clearError();
      this.dispatchEvent(new Event('input', { bubbles: true }));
      if (this.checkbox && this.checkbox.checked && this.textarea) {
        this.textarea.focus();
      }
    }

    onMessageInput() {
      this.updateCount();
      if (this.hasMessage()) this.clearError();
    }

    syncPanel() {
      if (!this.panel || !this.checkbox) return;
      const on = this.checkbox.checked;
      this.panel.hidden = !on;
      if (this.textarea) {
        this.textarea.required = on;
        this.textarea.setAttribute('aria-required', on ? 'true' : 'false');
      }
    }

    updateCount() {
      if (!this.counter || !this.textarea) return;
      const left = Math.max(0, this.max - this.textarea.value.length);
      const template = this.counter.getAttribute('data-template') || String(left);
      this.counter.textContent = template.replace('[count]', String(left));
    }

    hasMessage() {
      return !!(this.textarea && this.textarea.value.trim());
    }

    isComplete() {
      return !this.checkbox || !this.checkbox.checked || this.hasMessage();
    }

    validate() {
      if (this.isComplete()) {
        this.clearError();
        return true;
      }
      this.showError();
      return false;
    }

    showError() {
      this.classList.add('em-gift-note--error');
      if (this.error) this.error.hidden = false;
      if (this.textarea) {
        this.textarea.setAttribute('aria-invalid', 'true');
        this.textarea.focus();
      }
    }

    clearError() {
      this.classList.remove('em-gift-note--error');
      if (this.error) this.error.hidden = true;
      if (this.textarea) this.textarea.removeAttribute('aria-invalid');
    }

    getCombinedNote() {
      const customer = this.noteField ? this.noteField.value.trim() : '';
      if (!this.checkbox || !this.checkbox.checked) return customer;

      const gift = this.textarea ? this.textarea.value.trim() : '';
      if (!gift) return customer;

      const giftBlock = this.marker + ' ' + gift;
      return customer ? customer + '\n\n' + giftBlock : giftBlock;
    }

    ownsCheckout(target) {
      return this.root.contains(target);
    }

    isCheckoutTrigger(el) {
      if (!el) return false;
      if (el.matches('a[href*="/checkout"], [name="checkout"]')) return true;
      if (el.closest('.additional-checkout-buttons, .shopify-payment-button')) return true;
      return false;
    }

    onCheckoutClick(evt) {
      const target = evt.target.closest('a[href*="/checkout"], [name="checkout"], .additional-checkout-buttons a, .additional-checkout-buttons input, .shopify-payment-button');
      if (!this.isCheckoutTrigger(target) || !this.ownsCheckout(target)) return;
      if (this.validate()) return;

      evt.preventDefault();
      evt.stopPropagation();
    }

    onFormSubmit(evt) {
      if (this.validate()) return;
      evt.preventDefault();
    }
  }

  customElements.define('em-gift-note', EmGiftNote);
}
